import './style.scss'
import { useState, useContext, useRef } from 'react'
import AppInfoContext from 'src/provider/state-manager/appInfoProvider'
import VisibilityContext from 'src/provider/state-manager/visibilityProvider'
import UserContext from 'src/provider/state-manager/userProvider'
import { AbsoluteContainer, AppLabel, AppSpan, AppText, Button, CustomContainer, FlexRow, Form, FormGroup, ScreenContainer } from "src/style"
import utility, { handleTypeNumberControl } from "src/utils/utility"
import { useNavigate } from 'react-router-dom'
import { IoArrowBackOutline } from 'react-icons/io5'
import helpers from 'src/utils/helpers'
import { BsEye, BsEyeSlash } from 'react-icons/bs'


export const CredentialsCreationD3: React.FC<any> = () => {
    const navigate = useNavigate()
    const {notifier} = useContext(VisibilityContext)
    const {info, setInfoProperty} = useContext(AppInfoContext)
    const {user: {onboardingInput}, setUserProperty} = useContext(UserContext)
    const [input, setInput] = useState({
        username: onboardingInput.username || '', pin: onboardingInput.pin || '', confirmPin: onboardingInput.pin || '', 
        password: onboardingInput.password || '', confirmPassword: onboardingInput.password || ''
    })
    const [passwordCheck, setPasswordCheck] = useState({isValidPassword: true, isValidConfirmPassword: true, isRequirement: false})
    const [showPassword, setShowPassword] = useState({password: false, confirmPassword: false})
    const [pinCheck, setPinCheck] = useState({isValidPin: true, isValidConfirmPin: true})
    
    const passwordRef = useRef<any>(null)
    const confirmPaswordRef = useRef<any>(null)
    const pinRef = useRef<any>(null)
    const confirmPinRef = useRef<any>(null)

    const handleInput = (e: React.ChangeEvent<HTMLInputElement|HTMLTextAreaElement|HTMLSelectElement>) => {
        if ((e.target.name === 'pin' || e.target.name === 'confirmPin') && e.target.value.length > 4) return false
        //if ((e.target.name === 'password' || e.target.name === 'confirmPassword') && e.target.value.length > 6) return false
        if (e.target.name === 'password' || e.target.name === 'confirmPassword') {
            if (e.target.name === 'password') passwordRef.current = e.target.value
            if (e.target.name === 'confirmPassword') confirmPaswordRef.current = e.target.value
            handlePasswordCheck(true)
        }
        if (e.target.name === 'pin' || e.target.name === 'confirmPin') {
            if (e.target.name === 'pin') pinRef.current = e.target.value
            if (e.target.name === 'confirmPin') confirmPinRef.current = e.target.value
            handlePinCheck()
        }
        if (e.target.name === 'username' && e.target.value.includes(' ')) return false
        
        setInput({...input, [e.target.name]: e.target.value})
    }

    function handleInputFocus () {
        setPasswordCheck({...passwordCheck, isRequirement: true})
    }

    function handlePasswordCheck (showRequirement = false) {
        let {isValidPassword, isValidConfirmPassword, isRequirement} = passwordCheck
        isValidPassword = helpers.validatePassword(passwordRef.current)
        isValidConfirmPassword = helpers.validatePassword(confirmPaswordRef.current) && passwordRef.current === confirmPaswordRef.current
        isRequirement = showRequirement
        setPasswordCheck({isValidPassword, isValidConfirmPassword, isRequirement})
    }

    function handlePinCheck () {
        let {isValidPin, isValidConfirmPin} = pinCheck
        isValidPin = pinRef.current?.length === 4
        isValidConfirmPin = confirmPinRef.current?.length === 4 && pinRef.current === confirmPinRef.current
        setPinCheck({isValidPin, isValidConfirmPin})
    }

    async function handleSubmit(e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()
        if (input.pin.length != 4) return notifier.show('Kindly enter a four digit pin', 'Validation Response')
        if (!helpers.validatePassword(input.password)) return notifier.show('Invalid password. Kindly check the password requirement', 'Validation Response')
        if (input.pin != input.confirmPin) return notifier.show('PIN Confirmation did not match', 'Validation Response')
        if (input.password != input.confirmPassword) return notifier.show('Password Confirmation did not match', 'Validation Response')
        // if (input.password.length < 8) return notifier.show('Kindly enter atleast 6 characters password ', 'Validation Response')

        const data = {...input}
        delete data.confirmPassword
        delete data.confirmPin
        data.username = data.username.trim()
        setInfoProperty('onboardingProcessStatus', {...info.onboardingProcessStatus, isCredentialsCreated: true})
        setUserProperty('onboardingInput', {...onboardingInput, ...data})
        navigate('/onboarding/security-questions')
    }

    return (
        <ScreenContainer padding='2.5' height='auto' sizeUnit=''>
            <CustomContainer className='onboarding-screen-container'>
                <AppText 
                    textSize='3' color='#101828' 
                    bottomMargin='1.5' fontFamily='Gilmer-Bold'
                >
                    Create Login Credentials
                </AppText>
                <AppSpan>Create Username, PIN and Password</AppSpan>
                <Form topMargin='2.5' onSubmit={handleSubmit}>
                    <FormGroup>
                        <label>Username</label>
                        <input 
                            placeholder='Enter Preferred Username' 
                            name='username'
                            value={input.username}
                            onChange={handleInput}
                            autoComplete="off"
                            required
                        />
                    </FormGroup>
                    <FormGroup
                        borderColor={!pinCheck.isValidPin ? '#B42318' : ''}
                        noFocusBorder={!pinCheck.isValidPin ? true : false}
                    >
                        <label>PIN</label>
                        <input 
                            placeholder='XXXX'
                            type='password' 
                            name='pin'
                            value={input.pin}
                            onChange={handleInput}
                            autoComplete="new-password"
                            onKeyDown={handleTypeNumberControl}
                            onKeyUp={handleTypeNumberControl}
                            required
                        />
                    </FormGroup>
                    <FormGroup
                        borderColor={!pinCheck.isValidConfirmPin ? '#B42318' : ''}
                        noFocusBorder={!pinCheck.isValidConfirmPin ? true : false}
                    >
                        <label>Confirm PIN</label>
                        <input 
                            placeholder='XXXX' 
                            name='confirmPin'
                            type='password'
                            value={input.confirmPin}
                            onChange={handleInput}
                            autoComplete="off"
                            onKeyDown={handleTypeNumberControl}
                            onKeyUp={handleTypeNumberControl}
                            required
                        />
                    </FormGroup>
                    <FormGroup 
                        borderColor={!passwordCheck.isValidPassword ? '#B42318' : ''}
                        noFocusBorder={!passwordCheck.isValidPassword ? true : false}
                    >
                        <label>Password</label>
                        <input 
                            placeholder='XXXXXXX'
                            name='password' 
                            type={showPassword.password ? 'text' : 'password'}
                            value={input.password}
                            onChange={handleInput}
                            onFocus={handleInputFocus}
                            onBlur={() => handlePasswordCheck()}
                            autoComplete="off"
                            required
                        />
                        { !showPassword.password ?
                            <AbsoluteContainer bottom='1.2' right='1'>
                                <AppSpan 
                                    color='rgba(0, 0, 0, 0.5)' textSize='1.7' cursor='pointer'
                                    onClick={() => setShowPassword({...showPassword, password: true})}
                                >
                                    <BsEyeSlash/>
                                </AppSpan>
                            </AbsoluteContainer>
                            :
                            <AbsoluteContainer bottom='1.2' right='1'>
                                <AppSpan 
                                    color='rgba(0, 0, 0, 0.5)' textSize='1.7' cursor='pointer'
                                    onClick={() => setShowPassword({...showPassword, password: false})}
                                >
                                    <BsEye/>
                                </AppSpan>
                            </AbsoluteContainer>
                        }
                    </FormGroup>
                    <FormGroup 
                        borderColor={!passwordCheck.isValidConfirmPassword ? '#B42318' : ''}
                        noFocusBorder={!passwordCheck.isValidConfirmPassword ? true : false}
                    >
                        <label>Confirm Password</label>
                        <input 
                            placeholder='XXXXXXX' 
                            name='confirmPassword'
                            type={showPassword.confirmPassword ? 'text' : 'password'}
                            value={input.confirmPassword}
                            onChange={handleInput}
                            onFocus={handleInputFocus}
                            onBlur={() => handlePasswordCheck()}
                            autoComplete="off"
                            required
                        />
                        { !showPassword.confirmPassword ?
                            <AbsoluteContainer bottom='1.2' right='1'>
                                <AppSpan 
                                    color='rgba(0, 0, 0, 0.5)' textSize='1.7' cursor='pointer'
                                    onClick={() => setShowPassword({...showPassword, confirmPassword: true})}
                                >
                                    <BsEyeSlash/>
                                </AppSpan>
                            </AbsoluteContainer>
                            :
                            <AbsoluteContainer bottom='1.2' right='1'>
                                <AppSpan 
                                    color='rgba(0, 0, 0, 0.5)' textSize='1.7' cursor='pointer'
                                    onClick={() => setShowPassword({...showPassword, confirmPassword: false})}
                                >
                                    <BsEye/>
                                </AppSpan>
                            </AbsoluteContainer>
                        }
                    </FormGroup>
                    { passwordCheck.isRequirement &&
                        <CustomContainer 
                            radius='0.8' borderColor='#E7F6F5' bgColor='#E7F6F5'
                            padding='2' topPadding='1.5'
                        >
                            <AppLabel textSize='1.2' fontWeight='700' color='#0A756F'>Password Requirements</AppLabel>
                            <CustomContainer topMargin='0.5'>
                                <AppText textSize='1.2' color='#0A756F' bottomPadding='0.2' >Password must be at least 8 digits in length</AppText>
                                <AppText textSize='1.2' color='#0A756F' bottomPadding='0.2' >Password must contain at least 1 uppercase letter</AppText>
                                <AppText textSize='1.2' color='#0A756F' bottomPadding='0.2'>Password must contain at least 1 lowercase letter</AppText>
                                <AppText textSize='1.2' color='#0A756F' bottomPadding='0.2'>Password must contain at least 1 special character</AppText>
                                <AppText textSize='1.2' color='#0A756F' bottomPadding='0.2'>Example: Qore@1500$ </AppText>
                            </CustomContainer>
                        </CustomContainer>
                    }
                    <FlexRow justifyContent='flex-end' topMargin='2.5' gap='1.5'>
                        <Button 
                            width='9.3' height='4' bgColor="#ffffff"
                            borderColor='#D0D5DD' hoverBgColor='#ffffff' 
                            hoverColor='#0D968F' titleSize='1.4' color="#344054"
                            childHoverColor='#0D968F' type="button"
                            onClick={() => navigate(-1)}
                        >
                            <AppSpan color='#344054' rightMargin='1' textSize='1.6'>
                                <IoArrowBackOutline/>
                            </AppSpan>
                            Back
                        </Button>
                        <Button 
                            width='8.8' height='4' 
                            borderColor='#0D968F' hoverBgColor='#fff' 
                            hoverColor='#0D968F' titleSize='1.4'
                        >
                            Proceed
                        </Button>
                    </FlexRow>
                </Form>
            </CustomContainer>
        </ScreenContainer>
    )
}
